// Mock podaci za bend Kocka Šećera

export const bandInfo = {
  name: "Kocka Šećera",
  tagline: "Muzika koja zaslađuje svaku proslavu",
  description: "Profesionalni bend za sve vrste proslava na teritoriji cele Srbije. Sa dugogodišnjim iskustvom i repertoarom koji zadovoljava sve generacije, garantujemo nezaboravnu atmosferu na vašem događaju.",
  phone: "064 355 4992",
  email: "milos.kovacic@outlook.com",
  territory: "Teritorija cele Srbije",
  logo: "https://customer-assets.emergentagent.com/job_proslava-srbija/artifacts/5j6mm9yv_KS%20logo%20gold%20%281%29.png",
  heroImage: "https://customer-assets.emergentagent.com/job_d6cd3282-14a9-4414-b3c7-581f3467546a/artifacts/f5xc8v8a_kocka.png"
};

export const services = [
  {
    id: 1,
    title: "Svadbe",
    description: "Učinite vaš najsrećniji dan nezaboravnim uz savršenu muzičku pratnju koja će podići atmosferu na najviši nivo.",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Rođendani",
    description: "Proslavite posebne trenutke uz bend koji zna kako da zabavi goste svih generacija.",
    icon: "Cake"
  },
  {
    id: 3,
    title: "Korporativni eventi",
    description: "Profesionalna muzička oprema i nastup za vaše poslovne proslave i team building događaje.",
    icon: "Building"
  },
  {
    id: 4,
    title: "Krštenja i slave",
    description: "Tradicionalne proslave zaslužuju kvalitetnu muziku koja poštuje običaje i stvara toplu atmosferu.",
    icon: "Church"
  },
  {
    id: 5,
    title: "Maturske večeri",
    description: "Energična muzika i hits koji će učiniti vašu maturu nezaboravnom.",
    icon: "GraduationCap"
  },
  {
    id: 6,
    title: "Privatne proslave",
    description: "Bilo koja prilika za slavlje - mi smo tu da je muzički ulepšamo.",
    icon: "PartyPopper"
  }
];

export const gallery = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_d6cd3282-14a9-4414-b3c7-581f3467546a/artifacts/zgz7ejnu_IVAN9993.jpg",
    alt: "Pevačica benda Kocka Šećera"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_d6cd3282-14a9-4414-b3c7-581f3467546a/artifacts/hlnzctim_IVAN9965.jpg",
    alt: "Pevač benda Kocka Šećera"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_proslava-srbija/artifacts/onq2a9nx_IVAN9945.jpg",
    alt: "Nastup benda Kocka Šećera"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_proslava-srbija/artifacts/uy2439as_IVAN9912.jpg",
    alt: "Kocka Šećera - uživo"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_proslava-srbija/artifacts/xp9ldsgj_IVAN9951.jpg",
    alt: "Kocka Šećera - proslava"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marija i Nikola",
    event: "Svadba",
    text: "Bend Kocka Šećera je učinio našu svadbu apsolutno savršenom! Svi gosti su bili oduševljeni, a mi smo uživali u svakom trenutku.",
    rating: 5
  },
  {
    id: 2,
    name: "Petar Jovanović",
    event: "Korporativni event",
    text: "Profesionalizam na najvišem nivou. Preporučujem svima koji žele kvalitetnu muziku i odličnu atmosferu.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Petrović",
    event: "Rođendan",
    text: "Fantastičan bend! Repertoar za sve generacije, od starih hitova do najnovije muzike. Svi su plesali do kasno u noć!",
    rating: 5
  },
  {
    id: 4,
    name: "Jelena i Marko",
    event: "Svadba",
    text: "Od prve pesme do poslednje, atmosfera je bila neverovatna. Hvala vam što ste naš dan učinili nezaboravnim!",
    rating: 5
  },
  {
    id: 5,
    name: "Milan Stanković",
    event: "Slava",
    text: "Odličan izbor pesama i sjajna energija. Gosti i dan danas pričaju o proslavi. Topla preporuka!",
    rating: 5
  },
  {
    id: 6,
    name: "Ivana Nikolić",
    event: "Matursko veče",
    text: "Bend je napravio ludnicu na maturi! Svi smo pevali i igrali bez prestanka. Najbolja odluka koju smo doneli.",
    rating: 5
  }
];

export const navLinks = [
  { name: "Početna", href: "#home" },
  { name: "O nama", href: "#about" },
  { name: "Snimci", href: "#instagram" },
  { name: "Usluge", href: "#services" },
  { name: "Galerija", href: "#gallery" },
  { name: "Utisci", href: "#testimonials" },
  { name: "Kontakt", href: "#contact" }
];

// Instagram objave - dodajte URL-ove vaših Instagram postova/reels-a ovde
// Primer: "https://www.instagram.com/p/ABC123/" ili "https://www.instagram.com/reel/ABC123/"
export const instagramPosts = [
  { url: "https://www.instagram.com/bend_kockasecera/reel/DTgR6rCAoq5/" },
  { url: "https://www.instagram.com/bend_kockasecera/reel/DKaApWhMJcW/" },
  { url: "https://www.instagram.com/bend_kockasecera/reel/DNDFqJGsUdS/" },
];
